/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint array-element-newline: ["error", "never"] */
import React from 'react';
import {
    bool, string, number, arrayOf, shape, func,
} from 'prop-types';
import Button from '@material-ui/core/Button';
import { formatPhoneNumber } from '../../utils/formater';

const BillingInfo = (props) => {
    // eslint-disable-next-line object-curly-newline
    const { billingAddress, countries, onEdit } = props;
    return (
        <>
            <h2>Your Default Billing Address</h2>
            {billingAddress.map((address) => (
                <React.Fragment key={address.AddressBookEntryId}>
                    <div className="bold">
                        {address.FirstName} {address.LastName}
                    </div>
                    <div>{address.EmployerName}</div>
                    <div>
                        {address.Addresses[0].AddressLineOne}
                        {address.Addresses[0].AddressLineTwo
                            ? `, ${address.Addresses[0].AddressLineTwo}`
                            : ''}
                    </div>
                    <div>
                        {[
                            address.Addresses[0].City, address.Addresses[0].StateProvince, address.Addresses[0].PostalCode,
                        ].join(', ')}
                    </div>
                    <div>
                        {
                            countries.filter((c) => c.id === address.Addresses[0].Country)[0].name
                        }
                    </div>
                    <div>{formatPhoneNumber(address.PhoneNumber)}</div>
                    <div className="row margin-top">
                        <Button
                            variant="contained"
                            className="buttonHD margin-top margin-bottom-2x"
                            onClick={() => onEdit([address])}
                        >
                            Edit Billing Address
                        </Button>
                    </div>
                </React.Fragment>
            ))}
            {billingAddress.length === 0 ? (
                <>
                    <p>
                        You do not have billing address on file. Click the Add
                        Billing Address below to add a one.
                    </p>
                    <div className="row">
                        <Button
                            variant="contained"
                            className="buttonHD margin-top margin-bottom-2x"
                            onClick={() => onEdit()}
                        >
                            Add Billing Address
                        </Button>
                    </div>
                </>
            ) : (
                ''
            )}
        </>
    );
};

BillingInfo.propTypes = {
    billingAddress: arrayOf(
        shape({
            AddressBookEntryId: string,
            ContactId: number,
            FirstName: string,
            LastName: string,
            RelationShip: string,
            NickName: string,
            LastUpdateDate: string,
            PhoneNumber: string,
            EmployerName: string,
            NumberOfAddresses: number,
            Addresses: arrayOf(
                shape({
                    AddressId: number,
                    AddressBookEntryId: string,
                    AddressType: string,
                    AddressLineOne: string,
                    AddressLineTwo: string,
                    City: string,
                    StateProvince: string,
                    PostalCode: string,
                    Country: string,
                    IsPartialMatch: bool,
                    IsUnknownAddress: bool,
                    Latitude_degrees: number,
                    Longitude_degrees: number,
                    IsBillingAddress: bool,
                    ContactId: number,
                }),
            ),
        }),
    ).isRequired,
    countries: arrayOf(
        shape({
            id: string,
            name: string,
        }),
    ).isRequired,
    onEdit: func.isRequired,
};

export default BillingInfo;
